import React, { FCWithChildren } from 'react';
import styles from '@components/atoms/search-bar/search-bar.module.scss';
import clsx from 'clsx';

interface SearchBarListProps {
  label: string;
  editButton?: React.ReactNode;
  customClass?: string;
}

const SearchBarList: FCWithChildren<SearchBarListProps> = ({ label, customClass, editButton, children }) => {
  return (
    <li className={clsx(styles.searchbar__suggestionsWrapper, customClass)}>
      <div className={styles.searchbar__suggestionsTitle}>
        <h4 className={styles.searchbar__suggestionsTitle__text}>{label}</h4>
        {editButton}
      </div>
      <ul
        aria-label={label}
        className={styles.searchbar__resultList}
      >
        {children}
      </ul>
    </li>
  );
};

export default SearchBarList;
